<template>
    <div></div>
</template>

<script>
    export default {
        name: 'AuthenticationCheck',
        mounted() {
            setInterval(() => {
                if (!this.$cookies.get('authToken')) {
                    window.location.assign(window.location.origin + '/#/login');
                    window.location.reload();
                }
            }, 5000);
        }
    }
</script>
